var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSfcMemberBanner(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 364,
    height: 55,
    viewBox: "0 0 364 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 52.9453,
    width: 256.844,
    height: 42.3825,
    fill: "#B81F69"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.9418 23.4456H0.810547L17.3401 37.8737V39.6772L0.810547 54.1053H91.0874V42.3809H52.9418V23.4456Z",
    fill: "#B81F69"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9418 23.4456H0.810547L17.3401 37.8737V39.6772L0.810547 54.1053H91.0874V42.3809H52.9418V23.4456Z",
    fill: "black",
    fillOpacity: 0.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M309.788 23.4456H363.189L346.66 37.8737V39.6772L363.189 54.1053H272.835V42.3801H309.788V23.4456Z",
    fill: "#B81F69"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M309.788 23.4456H363.189L346.66 37.8737V39.6772L363.189 54.1053H272.835V42.3801H309.788V23.4456Z",
    fill: "black",
    fillOpacity: 0.25
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1561 42.3818H52.9453L91.1561 54.2148V42.3818Z",
    fill: "#B81F69"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1561 42.3818H52.9453L91.1561 54.2148V42.3818Z",
    fill: "black",
    fillOpacity: 0.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M272.834 42.3766L309.815 42.3766L272.834 54.1049V42.3766Z",
    fill: "#B81F69"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M272.834 42.3766L309.815 42.3766L272.834 54.1049V42.3766Z",
    fill: "black",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSfcMemberBanner);
export default __webpack_public_path__ + "static/media/sfc-member-banner.f517f13fe02c18e1b3008158c4724bf4.svg";
export { ForwardRef as ReactComponent };